import React, { useEffect, useState } from "react";
import { Check, ChevronsUpDown, Search } from "lucide-react";
import { api } from "../lib/api";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "./ui/command";
import { cn } from "../lib/utils";

const OTHER = { id: "__other__", name: "Other / Academy Not Listed" };

export function AcademySelect({ value, onChange, testId = "academy-select" }) {
  const [open, setOpen] = useState(false);
  const [academies, setAcademies] = useState([]);

  useEffect(() => {
    api.get("/academies").then(({ data }) => setAcademies([...data, OTHER])).catch(() => {});
  }, []);

  const selected = academies.find((a) => a.id === value?.id) || (value && !value.id && value.name ? OTHER : undefined);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          data-testid={testId}
          className="w-full flex items-center justify-between rounded-md border border-white/15 bg-[#0A0A0C] px-4 py-3 text-left text-sm text-white hover:border-yellow-400/40 transition-colors"
        >
          <span className={cn(!selected && "text-zinc-500")}>
            {selected ? selected.name : "Which Paragon academy or affiliate?"}
          </span>
          <ChevronsUpDown className="h-4 w-4 text-zinc-500" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-[--radix-popover-trigger-width] p-0 bg-[#121216] border-white/15">
        <Command className="bg-transparent">
          <div className="flex items-center border-b border-white/10 px-3">
            <Search className="h-4 w-4 text-zinc-500" />
            <CommandInput placeholder="Search academy..." className="text-white" />
          </div>
          <CommandList>
            <CommandEmpty>No academy found.</CommandEmpty>
            <CommandGroup>
              {academies.map((a) => (
                <CommandItem
                  key={a.id}
                  value={a.name}
                  data-testid={`academy-option-${a.id}`}
                  onSelect={() => {
                    onChange(a.id === "__other__" ? { id: null, name: a.name } : { id: a.id, name: a.name });
                    setOpen(false);
                  }}
                  className="text-white aria-selected:bg-white/10"
                >
                  <Check className={cn("mr-2 h-4 w-4 text-yellow-400", selected?.name === a.name ? "opacity-100" : "opacity-0")} />
                  {a.name}
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
